import * as React from "react";
import PropTypes from 'prop-types';

const SvgHome = props => {
  if (props.id !== "_svghome") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path fill="#333" d="M35.748 24.523L24.831 13.268a.89.89 0 00-.635-.268.88.88 0 00-.622.256l-.007.007c-1.062 1.088-2.48 2.536-3.42 3.493l-.001-.443a.888.888 0 00-.886-.887h-3.657a.888.888 0 00-.887.887v5.779l-2.451 2.418a.886.886 0 00.622 1.52h1.586v6.882c0 .49.397.887.886.887h6.452a.888.888 0 00.886-.887v-5.446h2.658v5.446c0 .49.397.887.886.887h6.425a.88.88 0 00.627-.26.88.88 0 00.259-.627v-6.883h1.561a.886.886 0 10.635-1.507" /></g></svg>;
};

SvgHome.displayName = "_svghome";
SvgHome.propTypes = {
  id: PropTypes.string
};
SvgHome.defaultProps = {
  id: ''
};
export default SvgHome;